/**
 * The zoom range the map can show. Shared with scripts/expand-tiles.mjs so
 * only tiles the map can actually request are generated and shipped.
 */
export const MAP_MIN_ZOOM = 12;
export const MAP_MAX_ZOOM = 15;
